import { NuqsAdapter } from "nuqs/adapters/react";
import React from "react";
import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";

import { PrivateRoute } from "@components/common";
import { TrackingServiceWrapper } from "@components/common/tracking-service-wrapper";
import { GrowthBookProvider } from "@components/growthbook.provider";
import {
  GROWTHBOOK_TRACKER_ID,
  PRIMARY_TRACKER_ID,
} from "@config/tracking-config";
import {
  useAppcuesSync,
  useDatadogRumUserSync,
  useRateLimitToast,
  useSentryUserSync,
} from "@lib/hooks";
import { RootPath } from "@lib/routes";
import { default as AppLayout } from "@src/layouts/app";

const Login = React.lazy(() => import("@views/account/login"));
const ForgotPassword = React.lazy(() =>
  import("@views/account/forgot-password")
);
const ResetPassword = React.lazy(() => import("@views/account/reset-password"));
const CreateAccount = React.lazy(() => import("@views/account/create-account"));
const ProProfsAuth = React.lazy(() => import("@views/account/proprofs-auth"));
const ProProfsLogout = React.lazy(() =>
  import("@views/account/proprofs-logout")
);

export default () => {
  useAppcuesSync();
  useSentryUserSync();
  useDatadogRumUserSync();
  useRateLimitToast();

  return (
    <Router>
      <NuqsAdapter>
        <TrackingServiceWrapper
          trackerId={PRIMARY_TRACKER_ID}
          collectorUrl={process.env.SNOWPLOW_COLLECTOR_URL}
          growthbookTrackerId={GROWTHBOOK_TRACKER_ID}
          growthbookCollectorUrl={process.env.SNOWPLOW_GROWTHBOOK_COLLECTOR_URL}
        >
          <Switch>
            <PrivateRoute path={RootPath}>
              <GrowthBookProvider>
                <AppLayout />
              </GrowthBookProvider>
            </PrivateRoute>
            <Route path="/login" component={Login} />
            <Route path="/forgot-password" component={ForgotPassword} />
            <Route path="/reset-password" component={ResetPassword} />
            <Route path="/create-account" component={CreateAccount} />
            <Route path="/proprofs-auth" component={ProProfsAuth} />
            <Route path="/proprofs-logout" component={ProProfsLogout} />
            <Route path="*">
              <Redirect to={RootPath} />
            </Route>
          </Switch>
        </TrackingServiceWrapper>
      </NuqsAdapter>
    </Router>
  );
};
